import { professionalTranslationFor } from './professionalTranslationRuntime.js';

const LABELS = {
  "en": [
    "Previous stage",
    "Next stage",
    "Journey summary",
    "Continue to"
  ],
  "fr": [
    "Étape précédente",
    "Étape suivante",
    "Résumé du parcours",
    "Continuer vers"
  ],
  "es": [
    "Etapa anterior",
    "Etapa siguiente",
    "Resumen del recorrido",
    "Continuar a"
  ],
  "it": [
    "Fase precedente",
    "Fase successiva",
    "Riepilogo del percorso",
    "Continua a"
  ],
  "pt": [
    "Etapa anterior",
    "Etapa seguinte",
    "Resumo do percurso",
    "Continuar para"
  ],
  "ro": [
    "Etapa anterioară",
    "Etapa următoare",
    "Rezumatul parcursului",
    "Continuă către"
  ],
  "pl": [
    "Poprzedni etap",
    "Następny etap",
    "Podsumowanie ścieżki",
    "Przejdź do"
  ],
  "tr": [
    "Önceki aşama",
    "Sonraki aşama",
    "Yolculuk özeti",
    "Devam et"
  ],
  "ar": [
    "المرحلة السابقة",
    "المرحلة التالية",
    "ملخص رحلة الرعاية",
    "الانتقال إلى"
  ],
  "fa": [
    "مرحله قبل",
    "مرحله بعد",
    "خلاصه مسیر مراقبت",
    "ادامه به"
  ],
  "ur": [
    "پچھلا مرحلہ",
    "اگلا مرحلہ",
    "نگہداشت کے سفر کا خلاصہ",
    "آگے جائیں"
  ],
  "bn": [
    "আগের ধাপ",
    "পরের ধাপ",
    "যাত্রার সারাংশ",
    "এগিয়ে যান"
  ],
  "gu": [
    "પાછલો તબક્કો",
    "આગલો તબક્કો",
    "યાત્રાનો સારાંશ",
    "આગળ વધો"
  ],
  "pa": [
    "ਪਿਛਲਾ ਪੜਾਅ",
    "ਅਗਲਾ ਪੜਾਅ",
    "ਯਾਤਰਾ ਦਾ ਸਾਰ",
    "ਅੱਗੇ ਜਾਓ"
  ],
  "so": [
    "Marxaladdii hore",
    "Marxaladda xigta",
    "Soo koobidda safarka",
    "U gudub"
  ],
  "tl": [
    "Nakaraang bahagi",
    "Susunod na bahagi",
    "Buod ng gabay",
    "Magpatuloy sa"
  ],
  "zh": [
    "上一阶段",
    "下一阶段",
    "就医指南总结",
    "继续前往"
  ]
};
const KEYS = ['previous', 'next', 'summary', 'continueTo'];
export function journeyStageNavigationCopy(language) {
  const code = String(language || 'en').toLowerCase().split('-')[0];
  return Object.fromEntries(KEYS.map((key,i) => [key, professionalTranslationFor(code, 'journeyStageNavigation', key) || (LABELS[code] || LABELS.en)[i]]));
}
